
function sortTable(n) {
  var table, rows, switching, i, x, y, shouldSwitch, dir, switchcount = 0;
  table = document.getElementById("searchTable");
  switching = true;
  dir = "down";
  while (switching) {
    switching = false;
    rows = table.rows;
    for (i = 1; i < (rows.length - 1); i++) {
      shouldSwitch = false;
      x = rows[i].getElementsByTagName("TD")[n];
      y = rows[i + 1].getElementsByTagName("TD")[n];
      if (dir == "down") {
        if (x.innerHTML.toLowerCase() > y.innerHTML.toLowerCase()) {
          shouldSwitch = true;

          break;
        }
      } else if (dir == "up") {
        if (x.innerHTML.toLowerCase() < y.innerHTML.toLowerCase()) {
          shouldSwitch = true;

          break;
        }
      }
    }
    if (shouldSwitch) {
      rows[i].parentNode.insertBefore(rows[i + 1], rows[i]);
      switching = true;
      switchcount ++;

    } else {
      if (switchcount == 0 && dir == "down") {
        dir = "up";
        switching = true;
      }
    }
  }
}
function sortTableInt(n) {
  var table, rows, switching, i, x, y, shouldSwitch, dir, switchcount = 0;
  table = document.getElementById("searchTable");
  switching = true;
  dir = "asc";
  while (switching) {
    switching = false;
    rows = table.rows;
    for (i = 1; i < (rows.length - 1); i++) {
      shouldSwitch = false;
      x = rows[i].getElementsByTagName("TD")[n];
      y = rows[i + 1].getElementsByTagName("TD")[n];
      var x_int = (x.innerHTML).replaceAll(',','')
      var y_int = (y.innerHTML).replaceAll(',','')
      if (dir == "asc") {
        if (parseInt(x_int) > parseInt(y_int))  {
          shouldSwitch = true;
          break;
        }
      } else if (dir == "desc") {
        if (parseInt(x_int) < parseInt(y_int))  {
          shouldSwitch = true;
          break;
        }
      }
    }
    if (shouldSwitch) {
      rows[i].parentNode.insertBefore(rows[i + 1], rows[i]);
      switching = true;
      switchcount ++;
    } else {
      if (switchcount == 0 && dir == "asc") {
        dir = "desc";
        switching = true;
      }
    }
  }
}

function sortTableFloat(n) {
  var table, rows, switching, i, x, y, shouldSwitch, dir, switchcount = 0;
  table = document.getElementById("searchTable");
  switching = true;
  dir = "down";
  while (switching) {
    switching = false;
    rows = table.rows;
    for (i = 1; i < (rows.length - 1); i++) {
      shouldSwitch = false;
      x = rows[i].getElementsByTagName("TD")[n];
      y = rows[i + 1].getElementsByTagName("TD")[n];
      var x_int = (x.innerHTML).replaceAll(',','')
      var y_int = (y.innerHTML).replaceAll(',','')
      if (dir == "down") {
        if (parseFloat(x_int) > parseFloat(y_int))  {
          shouldSwitch = true;
          break;
        }
      } else if (dir == "up") {
        if (parseFloat(x_int) < parseFloat(y_int))  {
          shouldSwitch = true;
          break;
        }
      }
    }
    if (shouldSwitch) {
      rows[i].parentNode.insertBefore(rows[i + 1], rows[i]);
      switching = true;
      switchcount ++;
    } else {
      if (switchcount == 0 && dir == "down") {
        dir = "up";
        switching = true;
      }
    }
  }
}

function extractNumericValue(cell) {
  // Extract the numeric value from a cell while ignoring special characters
  var text = cell.textContent;
  return parseFloat(text.replace(/[^0-9.-]+/g, ''));
}

function sortTableNew(n) {
  const table = document.getElementById("searchTable");
  let dir = table.getAttribute("data-sort-dir") || "down";
  const rows = Array.from(table.querySelectorAll('tbody > tr'));

  rows.sort((a, b) => {
    const x = a.cells[n].textContent.toLowerCase();
    const y = b.cells[n].textContent.toLowerCase();

    if (dir === "down") {
      return x.localeCompare(y);
    } else {
      return y.localeCompare(x);
    }
  });

  while (table.querySelector('tbody').children.length > 0) {
    table.querySelector('tbody').removeChild(table.querySelector('tbody').children[0]);
  }

  rows.forEach(row => {
    table.querySelector('tbody').appendChild(row);
  });

  dir = dir === "down" ? "up" : "down";
  table.setAttribute("data-sort-dir", dir);
}


function sortOppTableCurrencyInt(n) {
  const table = document.getElementById("searchTable");
  let dir = table.getAttribute("data-sort-dir") || "down";
  const tbody = table.querySelector('tbody');
  const rows = Array.from(tbody.querySelectorAll('tr'));

  rows.sort((a, b) => {
    const x = extractNumericValue(a.cells[n]);
    const y = extractNumericValue(b.cells[n]);

    return dir === "down" ? y - x : x - y;
  });

  rows.forEach(row => {
    tbody.removeChild(row);
  });

  rows.forEach(row => {
    tbody.appendChild(row);
  });

  dir = dir === "down" ? "up" : "down";
  table.setAttribute("data-sort-dir", dir);
}

export { sortTable, sortTableInt, sortTableFloat, sortTableNew, sortOppTableCurrencyInt };
